/* eslint-disable import/prefer-default-export */
import * as yup from 'yup';

export const FormSchema = yup.object().shape({
  zipcode: yup.string()
    .min(2, 'Too Short!')
    .max(20, 'Too Long!'),
  name: yup.string()
    .min(2, 'Too Short!')
    .max(50, 'Too Long!')
    .required('Required'),
  set_address: yup.string()
    .min(2, 'Too Short!')
    .max(200, 'Too Long!')
    .required('Required'),
  parking_address: yup.string()
    .min(2, 'Too Short!')
    .max(200, 'Too Long!'),
  parking_instructions: yup.string()
    .min(2, 'Too Short!')
    .max(50, 'Too Long!'),
  nearest_hospital_address: yup.string()
    .min(2, 'Too Short!')
    .max(200, 'Too Long!'),
  location_notes: yup.string()
    .min(2, 'Too Short!')
    .max(50, 'Too Long!'),
});
